<template>
    <div class="relative shadow-custom rounded-lg overflow-hidden cursor-pointer" @click="clickCampaign()">
        <div class="campaign-image" :style="{'background-image': `url('${campaign.fullImageUrl}')`}" data-cy="container_campaign_image">
             <div class="absolute top-2.5 text-a-white-ffffff text-12 text-center font-medium">
                <div v-if="isTagNew">
                    <img src="@/assets/image/img-tag-new.svg" data-cy="img_campaign_tag_new">
                    <div class="box-text" data-cy="text_campaign_tag_new">{{lbl.home.tag_new}}</div>
                </div>
                <div v-if="isTagPopular">
                    <img src="@/assets/image/img-tag-pop.svg" data-cy="img_campaign_tag_popular">
                    <div class="box-text" data-cy="text_campaign_tag_popular">{{lbl.home.tag_popular}}</div>
                </div>
            </div>
        </div>
        <div class="bg-white p-3 text-a-blue-2140a6" data-cy="container_campaign_content">
            <div class="h-12 font-bold text-16 leading-normal line-clamp-2" data-cy="text_campaign_name">
                {{campaign.name}}
            </div>
            <div class="flex items-center justify-between text-14 font-light pt-3 pb-1">
                <div class="text-a-red-ff4d4d" v-if="isFavourite && campaignExpire" data-cy="text_campaign_expire">
                    {{lbl.history.expire}}
                </div>
                <div class="text-a-blue-2140a6" v-else data-cy="text_campaign_point">
                    {{getPointMessage()}}
                </div>
                <div>
                    <img :src="icFavUrl('ic-fav-active-small')" v-if="campaign.isFavourite || isFavourite" data-cy="img_campaign_favourite_active" />
                    <img :src="icFavUrl('ic-fav-inactive-small')" v-else data-cy="img_campaign_favourite_inactive" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
        isFavourite: { type: Boolean, default: false },
        typeTagCamp: { type: Object },
    },
    data: function() {
        return {
            isTagNew: false,
            isTagPopular: false
        }
    },
    computed: {
        campaignExpire: function(){
            return (this.campaign.currentDate > this.campaign.expireDate);
        }
    },
    watch: {
        typeTagCamp: function(tag) {
            this.tagNewAndPopular(tag);
        }
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + Util.formatNum(this.campaign.pointPerUnit) + " " + pointUnit;
        },

        clickCampaign: function() {
            if(this.isFavourite){
                this.tracking.event('history_favorite', 'click_history_favorite_campaign', this.campaign.id, null);
            }else{
                this.tracking.event('home_reward', 'click_campaign', this.campaign.id, null);
            }
            
            this.$router.push('/campaign/' + this.campaign.id);
        },
        tagNewAndPopular: function(tag) {
            tag.filter( camp => {
                if (camp.type == 'new' && camp.id == this.campaign.id) {
                    this.isTagNew = true;
                } else if (camp.type == 'popular' && camp.id == this.campaign.id) {
                    this.isTagPopular = true;
                }
            });
        },
        icFavUrl: function(name) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/${name}.svg`;
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .box-text {
        margin-top: -17px;
    }
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
